import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IOAuthCredential } from '../types/IOAuthCredential';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetOAuthCredentialsResult extends IGetItemsResult {
  credentials: IOAuthCredential[];
}

export class GetOAuthCredentialsRequest extends Request<IGetItemsParams, IGetOAuthCredentialsResult> {
  constructor(params: IGetItemsParams) {
    super('getOAuthCredentials', params);
  }
}
